// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"55de1031","33":"ac0ed49e","135":"47119fd7","252":"3fa3248f","494":"d3ebbd3d","805":"69f44e2c","927":"b531ae9a"}[chunkId] + ".chunk.js";
};